import {
  createContext,
  type ReactNode,
  useContext,
  useEffect,
  useMemo,
  useState
} from 'react';
import { useSettings } from '@wu/widget-core';

type SearchContextValue = {
  searchValue: string;
  setSearchValue: (value: string) => void;
  reset: () => void;
};

const SearchContext = createContext<SearchContextValue | undefined>(undefined);

type SearchProviderProps = {
  children: ReactNode;
};

export function SearchProvider({ children }: SearchProviderProps) {
  const { searchEnabled } = useSettings();
  const [searchValue, setSearchValue] = useState('');

  const value = useMemo(
    () => ({
      searchValue,
      setSearchValue,
      reset: () => setSearchValue('')
    }),
    [searchValue]
  );

  useEffect(() => {
    setSearchValue('');
  }, [searchEnabled]);

  return (
    <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
  );
}

export function useSearch(): SearchContextValue {
  const context = useContext(SearchContext);

  if (!context) {
    throw new Error('useSearch must be used within a SearchProvider');
  }

  return context;
}
